import { render, staticRenderFns } from "./RoundCard.vue?vue&type=template&id=412e1153&scoped=true&"
import script from "./RoundCard.vue?vue&type=script&lang=js&"
export * from "./RoundCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundCard.vue?vue&type=style&index=0&id=412e1153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e1153",
  null
  
)

export default component.exports